import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getParentList, getChildList, remove, update, add, getDict, getDictTree, queryTenantList } from "@/api/system/dictbiz";
import { optionParent, optionChild } from "@/const/system/dictbiz";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      dictValue: '暂无',
      parentId: -1,
      formParent: {},
      formChild: {},
      selectionList: [],
      query: {},
      tenantList: [],
      tenantVal: '',
      loading: true,
      loadingChild: true,
      pageParent: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      pageChild: {
        pageSize: 10,
        pageSizes: [10, 30, 50, 100, 200],
        currentPage: 1,
        total: 0
      },
      dataParent: [],
      dataChild: [],
      optionParent: optionParent,
      optionChild: optionChild
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.dictbiz_add, false),
        delBtn: this.vaildData(this.permission.dictbiz_delete, false),
        editBtn: this.vaildData(this.permission.dictbiz_edit, false),
        viewBtn: false
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      var _this = this;

      getDictTree().then(function (res) {
        var column = _this.findObject(_this.optionChild.column, "parentId");

        column.dicData = res.data.data;
      });
      this.getTenantList();
    },
    getTenantList: function getTenantList() {
      var _this2 = this;

      if (!this.tenantVal) {
        queryTenantList().then(function (res) {
          console.log(res, '--res');
          _this2.tenantList = res.data.data;
          _this2.tenantVal = _this2.tenantList[0].tenantId;
        });
      }
    },
    handleAdd: function handleAdd(row) {
      this.$refs.crudChild.value.parentId = row.id;
      this.$refs.crudChild.option.column.filter(function (item) {
        if (item.prop === "parentId") {
          item.value = row.id;
        }
      });
      this.$refs.crudChild.rowAdd();
    },
    rowSave: function rowSave(row, done, loading) {
      var _this3 = this;

      var form = _objectSpread(_objectSpread({}, row), {}, {
        dictKey: -1,
        tenantId: this.tenantVal
      });

      add(form).then(function () {
        _this3.onLoadParent(_this3.pageParent);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this4 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      update(data).then(function () {
        _this4.onLoadParent(_this4.pageParent);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this5 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id, _this5.tenantVal);
      }).then(function () {
        _this5.onLoadParent(_this5.pageParent);

        _this5.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    handleRowClick: function handleRowClick(row) {
      this.query = {};
      this.parentId = row.id;
      this.dictValue = row.dictValue;
      this.$refs.crudChild.value.code = row.code;
      this.$refs.crudChild.value.parentId = row.id;
      this.$refs.crudChild.option.column.filter(function (item) {
        if (item.prop === "code") {
          item.value = row.code;
        }

        if (item.prop === "parentId") {
          item.value = row.id;
        }
      });
      this.onLoadChild(this.pageChild);
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoadParent(this.pageParent);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.pageParent.currentPage = 1;
      this.onLoadParent(this.pageParent, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this6 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this6.ids, _this6.tenantVal);
      }).then(function () {
        _this6.onLoadParent(_this6.pageParent);

        _this6.$message({
          type: "success",
          message: "操作成功!"
        });

        _this6.$refs.crud.toggleSelection();
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this7 = this;

      if (["edit", "view"].includes(type)) {
        getDict(this.formParent.id, this.tenantVal).then(function (res) {
          _this7.formParent = res.data.data;
        });
      }

      done();
    },
    currentChange: function currentChange(currentPage) {
      this.pageParent.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.pageParent.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoadParent(this.pageParent, this.query);
    },
    rowSaveChild: function rowSaveChild(row, done, loading) {
      var _this8 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      add(data).then(function () {
        _this8.onLoadChild(_this8.pageChild);

        _this8.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdateChild: function rowUpdateChild(row, index, done, loading) {
      var _this9 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      update(data).then(function () {
        _this9.onLoadChild(_this9.pageChild);

        _this9.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDelChild: function rowDelChild(row) {
      var _this10 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id, _this10.tenantVal);
      }).then(function () {
        _this10.onLoadChild(_this10.pageChild);

        _this10.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchResetChild: function searchResetChild() {
      this.query = {};
      this.onLoadChild(this.pageChild);
    },
    searchChangeChild: function searchChangeChild(params, done) {
      this.query = params;
      this.pageChild.currentPage = 1;
      this.onLoadChild(this.pageChild, params);
      done();
    },
    selectionChangeChild: function selectionChangeChild(list) {
      this.selectionList = list;
    },
    selectionClearChild: function selectionClearChild() {
      this.selectionList = [];
      this.$refs.crudChild.toggleSelection();
    },
    handleDeleteChild: function handleDeleteChild() {
      var _this11 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this11.ids, _this11.tenantVal);
      }).then(function () {
        _this11.onLoadChild(_this11.pageChild);

        _this11.$message({
          type: "success",
          message: "操作成功!"
        });

        _this11.$refs.crudChild.toggleSelection();
      });
    },
    beforeOpenChild: function beforeOpenChild(done, type) {
      var _this12 = this;

      if (["add", "edit"].includes(type)) {
        this.initData();
      }

      if (["edit", "view"].includes(type)) {
        getDict(this.formChild.id, this.tenantVal).then(function (res) {
          _this12.formChild = res.data.data;
        });
      }

      done();
    },
    beforeCloseChild: function beforeCloseChild(done) {
      var _this13 = this;

      this.$refs.crudChild.value.parentId = this.parentId;
      this.$refs.crudChild.option.column.filter(function (item) {
        if (item.prop === "parentId") {
          item.value = _this13.parentId;
        }
      });
      done();
    },
    currentChangeChild: function currentChangeChild(currentPage) {
      this.pageChild.currentPage = currentPage;
    },
    sizeChangeChild: function sizeChangeChild(pageSize) {
      this.pageChild.pageSize = pageSize;
    },
    refreshChangeChild: function refreshChangeChild() {
      this.onLoadChild(this.pageChild, this.query);
    },
    onLoadParent: function onLoadParent(page) {
      var _this14 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loading = true;
      getParentList(page.currentPage, page.pageSize, Object.assign(params, this.query, {
        tenantId: this.tenantVal
      })).then(function (res) {
        var data = res.data.data;
        _this14.pageParent.total = data.total;
        _this14.dataParent = data.records;
        _this14.loading = false;

        _this14.selectionClear();
      });
    },
    onLoadChild: function onLoadChild(page) {
      var _this15 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.loadingChild = true;
      getChildList(page.currentPage, page.pageSize, this.parentId, Object.assign(params, this.query, {
        tenantId: this.tenantVal
      })).then(function (res) {
        _this15.dataChild = res.data.data;
        _this15.loadingChild = false;

        _this15.selectionClear();
      });
    }
  }
};